export enum CATEGORY_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED"
}

export enum StoreStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  DELETED = "DELETED",
  INACTIVE = "INACTIVE"
}

export enum UserRole {
  STORE_ADMIN = "STORE_ADMIN",
  INVENTORY_CLERK = "INVENTORY_CLERK",
  WAREHOUSE_MANAGER = "WAREHOUSE_MANAGER",
  SALES_PROCUREMENT = "SALES_PROCUREMENT",
  BUYER = "BUYER",
  ANALYST = "ANALYST",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  STORE_MANAGER = "STORE_MANAGER"
}

export enum AccountStatus {
  INVITED = "INVITED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  DELETED = "DELETED"
}
